export default "__VITE_PUBLIC_ASSET__6561f579__"